import script from "./ip-address-blocking-log.vue?vue&type=script&setup=true&lang=ts"
export * from "./ip-address-blocking-log.vue?vue&type=script&setup=true&lang=ts"

import "./ip-address-blocking-log.vue?vue&type=style&index=0&id=d204210a&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d204210a"]])

export default __exports__